export default __webpack_public_path__ + "static/media/buttom.14dc9c16.png";